(()=>{'use strict';
 const source=new URL(location.href),values=source.searchParams.getAll('pb_package'),variantValues=source.searchParams.getAll('variant');
 const tier=values.length===1&&/^[123]$/.test(values[0])?Number(values[0]):0;
 window.PBBundleEntry=Object.freeze({register(o){
  if(!values.length)return;
  const start=()=>{
   const clean=new URL(location.href);clean.searchParams.delete('pb_package');history.replaceState(history.state,'',clean.pathname+clean.search+clean.hash);
   if(!tier||variantValues.length!==1||variantValues[0]!==String(o.variants[0]?.id))return;
   const root=o.form.closest('[data-product-id]');if(!root||root.dataset.productId!==String(o.model.id))return;
   let current=tier;
   const native=o.form.querySelector('[data-add-to-cart]'),express=o.form.querySelector('.shopify-payment-button');
   const nativeHidden=native?.hidden,expressHidden=express?.hidden;
   const existing=root.querySelector('[data-pb-bundle-preview]');
   let field=existing,button,status;
   if(!field){
    field=o.equipment;field.dataset.pbEntryEquipment='true';field.style.display='block';
    status=field.querySelector('.pb-coral-package-status');
    button=document.createElement('button');button.type='button';button.className='btn btn--full';button.textContent='Gewähltes Fahrradpaket';button.dataset.pbEntryPurchase='';field.append(button);
    button.addEventListener('click',async()=>{if(button.disabled||!o.available(current))return;button.disabled=true;status.textContent='Paket wird im Warenkorb geprüft …';try{await o.purchase(current,status);}finally{sync();}});
   }
   const links=Array.from(root.querySelectorAll('.pb-pdp-colours a')),originalLinks=links.map(a=>a.getAttribute('href'));
   const data=JSON.parse(document.querySelector('#pb-coral-product-data')?.textContent||'{}');
   const radioFor=n=>field.querySelector('input[type="radio"][value="'+n+'"]');
   const sync=()=>{
    const chosen=field.querySelector('input[type="radio"]:checked');current=Number(chosen?.value||0);
    if(!existing){
     if(o.mobile.matches){if(native)native.hidden=nativeHidden;if(express)express.hidden=expressHidden;}
     if(!o.mobile.matches){const target=root.querySelector('[data-product-blocks]');if(target&&!target.contains(field))target.prepend(field);}
     button.hidden=o.mobile.matches||!current;button.style.display=button.hidden?'none':'';button.disabled=!current||!o.available(current)||!!chosen?.disabled;
     if(native&&!o.mobile.matches)native.hidden=current>0?true:nativeHidden;
     if(express&&!o.mobile.matches)express.hidden=current>0?true:expressHidden;
    }
    links.forEach((a,i)=>{const url=new URL(originalLinks[i],location.origin),handle=url.pathname.split('/').pop(),v=data[handle]?.variants?.[0];if(current&&v){url.searchParams.set('variant',String(v.id));url.searchParams.set('pb_package',String(current));a.href=url.pathname+url.search+url.hash;}else a.setAttribute('href',originalLinks[i]);});
   };
   const radio=radioFor(tier);if(!radio)return;
   radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));
   if(radio.disabled&&status)status.textContent='Dieses Paket ist für die gewählte Farbe oder Lieferung derzeit nicht bestellbar.';
   field.addEventListener('change',sync);o.mobile.addEventListener('change',sync);sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 }});
})();